import React, { useState } from 'react';
import Layout from '../../common/Layout';
import { dispatchMmvData } from '../../store/actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import { PostDataWithToken } from '../../constants/ApiHelper';
import { toast } from 'react-toastify';

const ExportMaster = () => {
  const mmvData = useSelector(state => state?.root?.mmvData);
  const dispatch = useDispatch();

  const [vehicleType, setVehicleType] = useState('');
  const [uploadType, setUploadType] = useState('');
  const [loading, setLoading] = useState(false);

  const [exportHistory, setExportHistory] = useState([]);

  // ================= VEHICLE =================
  const handleVehicle = (val) => {
    setVehicleType(val);
    dispatchMmvData('vehicleType', val);
  };

  const handleMasterType = (e) => {
    const value = e.target.value;
    dispatchMmvData('masterType', value);
    setUploadType(value);
  };

  // ================= DOWNLOAD FUNCTION =================
  const downloadFile = (downloadUrl) => {
    try {
      window.location.assign(downloadUrl);
      toast.success('Download started!');
    } catch (error) {
      console.error('Download error:', error);
      toast.error('Failed to download file');
    }
  };

  // ================= UPLOAD HANDLER =================
  const handleUpload = async () => {
    if (!vehicleType || !uploadType) {
      toast.error('Please fill all required fields');
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append('tableName', uploadType);
    formDataToSend.append('vehicleType', vehicleType);

    try {
      setLoading(true);

      const response = await PostDataWithToken(
        'export-master/export-base-master',
        formDataToSend
      );

      if (response?.status) {
        toast.success(response?.message || 'Exported successfully!');

        const newExport = {
          id: Date.now(),
          downloadUrl: response?.data?.downloadUrl,
          vehicleType,
          masterType: uploadType,
          timestamp: new Date().toLocaleString(),
        };

        setExportHistory([newExport, ...exportHistory]);

        if (response?.data?.downloadUrl) {
          downloadFile(response.data.downloadUrl);
        }

        setVehicleType('');
        setUploadType('');
      } else {
        toast.error(response?.message || 'Export failed. Please try again.');
      }
    } catch (error) {
      console.error('Upload Error:', error);
      toast.error(error?.message || 'Upload error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="mt-7 mx-4">
        {/* ================= EXPORT CARD ================= */}
        <div className="card mb-4">
          <div className="card-header text-white">
            <h5 className="mb-0">Export Master Data</h5>
          </div>
          <div className="card-body">
            <div className="row">
              {/* VEHICLE TYPE */}
              <div className="col-md-4">
                <label className="form-label">
                  Vehicle Type <span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  value={vehicleType}
                  onChange={(e) => handleVehicle(e.target.value)}
                >
                  <option value="">Select Vehicle</option>
                  <option value="2w">Two Wheeler</option>
                  <option value="4w">Private Car</option>
                  <option value="pcv">Passenger Carrying Vehicle</option>
                  <option value="gcv">Goods Carrying Vehicle</option>
                  <option value="misc">Miscellaneous Vehicle</option>
                </select>
              </div>

              {/* MASTER TYPE */}
              <div className="col-md-4">
                <label className="form-label">
                  Master Type <span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  value={uploadType}
                  onChange={handleMasterType}
                >
                  <option value="">Select Master Type</option>
                  <option value="mmv_models">MMV</option>
                  <option value="rto_models">RTO</option>
                  <option value="pincode_models">Pincode</option>
                  <option value="relation_models">Relation</option>
                  <option value="prevInsurer_models">Prev Insurer</option>
                  <option value="financier_models">Financier</option>
                  <option value="occupation_models">Occupation</option>
                  <option value="exshowroom_models">Ex Showroom</option>
                </select>
              </div>

              <div className="col-md-3 mt-4 d-flex gap-2">
                <button
                  className="btn btn-sec flex-grow-1"
                  onClick={handleUpload}
                  disabled={loading || !vehicleType || !uploadType}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Exporting...
                    </>
                  ) : (
                    '📥 Export & Download'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* ================= LOADING OVERLAY ================= */}
        {loading && (
          <div
            className="loader-overlay"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 9999,
            }}
          >
            <div className="text-center text-white">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <h5 className="mt-3">Exporting Master Data...</h5>
              <p className="text-muted">Please wait, this may take a moment</p>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default ExportMaster;
